import React from 'react';

import { Pagination as AntdPagination, Typography } from 'antd';
import styled from 'styled-components';

const StyledPagination = styled(AntdPagination)`
  &&.ant-pagination {
    font-size: 12px;

    .ant-pagination-item {
      line-height: 32px;
      color: var(--text-primary);
      border-radius: 32px;
    }

    .ant-pagination-item-active {
      border-radius: 32px;
      box-shadow: 0 2px 6px 0 var(--box-shadow-gray);
      background-color: white;
      border: none;
      a {
        color: var(--text-primary) !important;
      }
    }
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 21px 15px 0 4px;
`;

const PaginationText = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
`;

type Props = {
  page: number;
  pageSize: number;
  total: number;
  currentPageCount: number;
  onPageChange: (page: number) => void;
};

const CmiDigestAdminPagination = ({ page, pageSize, total, currentPageCount, onPageChange }: Props) => {
  if (total === 0) {
    return null;
  }

  return (
    <PaginationContainer data-test-id="cmi-digest-admin-pagination">
      <StyledPagination
        total={total}
        current={page}
        pageSize={pageSize}
        onChange={onPageChange}
        showSizeChanger={false}
      />
      <PaginationText>
        Showing {currentPageCount} of {total} records
      </PaginationText>
    </PaginationContainer>
  );
};

export default CmiDigestAdminPagination;
